import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-update-profile-success',
  templateUrl: './update-profile-success.component.html',
  styleUrls: ['./update-profile-success.component.scss'],
})
export class UpdateProfileSuccessComponent implements OnInit {

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }

}
